import { styled } from "@mui/material";
import Loader from "./Loader";

const LoaderOverlayUnstyled = ({
  zIndex = 1,
  size = 50,
  className,
  withoutBackground,
}) => (
  <Loader
    size={size}
    className={className}
    sx={{
      zIndex,
      position: "absolute",
      top: 0,
      left: 0,
      backgroundColor: withoutBackground ? "transparent" : "#000",
      opacity: withoutBackground ? 1 : 0.4,
    }}
  />
);

const LoaderOverlay = styled(LoaderOverlayUnstyled)({});

export default LoaderOverlay;
